<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/SearchBar.vue';
import TableContainer from './Table/TableDataManagementTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchContainer,
		TableContainer
	}
};
</script>

<style SearchContainer></style>
